module.exports = {
    Forecasts: require('./forecasts.js')
}